/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const ICON_SIZE = 16;
export const ICONS_PER_ROW = 2;

export const IconsWrapper = styled(Box)(() => ({
  width: ICON_SIZE * ICONS_PER_ROW,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0,
  alignItems: 'flex-start',
  justifyContent: 'center',
  flexShrink: 0,
}));
